module.exports = __webpack_public_path__ + "img/88.7eb3760b.jpg";